
export default {
  name: 'PagesAboutExtentionsStreams',
  props: {
    streams: {
      type: Array,
      default: null,
    },
    countAllStreams: {
      type: Number,
      default: null,
    },
  },
  methods: {
    materials(stream) {
      return (
        stream.statistics?.articles?.publishedCount +
        stream.statistics?.telegram?.publishedCount
      )
    },
  },
}
